// extracted by mini-css-extract-plugin
export default {"root":"Shards_root__6r4yH","canvas":"Shards_canvas__59SUI","back":"Shards_back__qbpyl","content":"Shards_content__0bFIq","front":"Shards_front__kPV5e"};